import { ItemEnum, PaymentsStatusEnum, PaymentTermsCategory, PerforationEnum } from "@project-management-system/shared-models";


export class PaymentsDTO{
    paymentsId : number;
    controlNumber:string;
    paymentCode : string;
    poId:number;
    grnId:number;
    materialType:ItemEnum;
    status:PaymentsStatusEnum;
    refNo:number;
    invoiceAmount:number;
    advancePayment:PerforationEnum;
    isActive: boolean;
    createdUser : string;
    updatedUser : string;

    constructor( paymentsId : number,
        controlNumber:string,
        paymentCode : string,
        poId:number,
        grnId:number,
        materialType:ItemEnum,
        status:PaymentsStatusEnum,
        refNo:number,
        invoiceAmount:number,
        advancePayment:PerforationEnum,
        isActive: boolean,
        createdUser : string,
        updatedUser : string){
            this.paymentsId = paymentsId,
            this.controlNumber= controlNumber,
            this.paymentCode = paymentCode,
            this.poId= poId,
            this.grnId= grnId,
            this.materialType= materialType,
            this.status= status,
            this.refNo= refNo,
            this.invoiceAmount= invoiceAmount,
            this.advancePayment= advancePayment,
            this.isActive= isActive,
            this.createdUser =  createdUser,
            this.updatedUser =  updatedUser

    }
}